import React from "react";
import { Box } from "@mui/material";

const BRAND_TEAL = "#0D9EAF";
const BRAND_TEAL_LIGHT = "#69C9D2";
const BRAND_BROWN = "#D69A3A";

export default function SehoLoadingSpinner({
  variant = "card",
  centerContent = null,
  sx = {},
}) {
  const isOverlay = variant === "overlay";

  const spinnerSize = isOverlay
    ? {
        xs: 128,
        sm: 148,
      }
    : 58;

  const innerInset = isOverlay
    ? {
        xs: 17,
        sm: 20,
      }
    : 9;

  const centerSize = isOverlay
    ? {
        xs: 28,
        sm: 32,
      }
    : 14;

  return (
    <Box
      role="status"
      aria-label="Loading"
      sx={{
        "@keyframes sehoSpinClockwise": {
          "0%": {
            transform: "rotate(0deg)",
          },
          "100%": {
            transform: "rotate(360deg)",
          },
        },
        "@keyframes sehoSpinCounter": {
          "0%": {
            transform: "rotate(360deg)",
          },
          "100%": {
            transform: "rotate(0deg)",
          },
        },
        "@keyframes sehoPulse": {
          "0%": {
            transform: "scale(0.92)",
            opacity: 0.75,
          },
          "50%": {
            transform: "scale(1)",
            opacity: 1,
          },
          "100%": {
            transform: "scale(0.92)",
            opacity: 0.75,
          },
        },
        position: "relative",
        width: spinnerSize,
        height: spinnerSize,
        display: "grid",
        placeItems: "center",
        flexShrink: 0,
        pointerEvents: centerContent ? "auto" : "none",
        ...sx,
      }}
    >
      {/* glow */}
      <Box
        sx={{
          position: "absolute",
          inset: isOverlay
            ? {
                xs: 8,
                sm: 10,
              }
            : 4,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(13,158,175,0.12) 0%, rgba(214,154,58,0.08) 55%, rgba(255,255,255,0) 75%)",
          animation: "sehoPulse 1.8s ease-in-out infinite",
        }}
      />

      {/* outer ring */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          borderRadius: "50%",
          border: isOverlay
            ? "5px solid rgba(13,158,175,0.14)"
            : "3px solid rgba(13,158,175,0.14)",
          borderTopColor: BRAND_TEAL,
          borderRightColor: BRAND_BROWN,
          animation: "sehoSpinClockwise 1.1s linear infinite",
        }}
      />

      {/* inner ring */}
      <Box
        sx={{
          position: "absolute",
          inset: innerInset,
          borderRadius: "50%",
          border: isOverlay
            ? "4px solid rgba(214,154,58,0.14)"
            : "2px solid rgba(214,154,58,0.14)",
          borderBottomColor: BRAND_BROWN,
          borderLeftColor: BRAND_TEAL_LIGHT,
          animation: "sehoSpinCounter 1.6s linear infinite",
        }}
      />

      {centerContent ? (
        <Box
          sx={{
            position: "relative",
            zIndex: 2,
            display: "grid",
            placeItems: "center",
            pointerEvents: "auto",
          }}
        >
          {centerContent}
        </Box>
      ) : (
        <Box
          sx={{
            width: centerSize,
            height: centerSize,
            borderRadius: "50%",
            background: `linear-gradient(135deg, ${BRAND_TEAL} 0%, ${BRAND_BROWN} 100%)`,
            boxShadow: isOverlay
              ? "0 0 0 8px rgba(13,158,175,0.08), 0 0 0 16px rgba(214,154,58,0.05)"
              : "0 0 0 5px rgba(13,158,175,0.08), 0 0 0 9px rgba(214,154,58,0.05)",
            animation: "sehoPulse 1.6s ease-in-out infinite",
            zIndex: 2,
          }}
        />
      )}
    </Box>
  );
}